// Reusable Excel export — builds an .xls (HTML-table) file that opens natively
// in Excel/LibreOffice/Google Sheets, with proper columns. Zero dependencies.
//
// usage: exportExcel('Store stock', columns, rows)
//   columns: [{ key, label }]
//   rows: array of objects
export function exportExcel(filename, columns, rows) {
  const esc = (v) => String(v == null ? '' : v)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  const head = columns.map((c) => `<th style="background:#1B2A4A;color:#fff;padding:6px 10px;text-align:left">${esc(c.label)}</th>`).join('');
  const body = rows.map((r) => {
    const tds = columns.map((c) => {
      const val = typeof c.value === 'function' ? c.value(r) : r[c.key];
      const num = typeof val === 'number';
      return `<td style="padding:5px 10px;${num ? 'mso-number-format:\\0022#,##0\\0022;' : ''}">${esc(val)}</td>`;
    }).join('');
    return `<tr>${tds}</tr>`;
  }).join('');
  const html =
    `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
     <head><meta charset="utf-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>
     <x:Name>Sheet1</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet>
     </x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head>
     <body><table border="1" cellspacing="0">${`<thead><tr>${head}</tr></thead>`}<tbody>${body}</tbody></table></body></html>`;
  const blob = new Blob(['\ufeff', html], { type: 'application/vnd.ms-excel' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  const stamp = new Date().toISOString().slice(0, 10);
  a.href = url; a.download = `${filename}_${stamp}.xls`;
  document.body.appendChild(a); a.click();
  document.body.removeChild(a); URL.revokeObjectURL(url);
}
